import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 8V11H2V13H18V16L22 12L18 8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SmallLongRight"
);
